module.exports = __webpack_public_path__ + "assets/d10413661c4ea10d0033f900531ceea3.svg";